import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { Box } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    // boxShadow: `0px 0px 9px ${theme.palette.KenColors.shadowColor}`,
    borderRadius: 3,
    [theme.breakpoints.up("md")]: {
      padding: 40,
    },
    [theme.breakpoints.down("sm")]: {
      padding: 8,
    },
    marginTop: 10,
    [theme.breakpoints.down("sm")]: {
      padding: 12,
    },
  },
  examTitle: {
    textAlign: "start",
    marginBottom: 20,
    fontSize: 14,
    // color: "#193890fa",
    fontWeight: "bold",
    backgroundColor: "rgba(125,178,245,0.2)",
    color: "#0c4ea2",
  },
}));

export default function KenCard(props) {
  const { title } = props;

  const classes = useStyles();

  return (
    <React.Fragment>
      {/* <Typography className={classes.mainTitle}></Typography> */}
      <Paper elevation={0} className={classes.root} data-testid="KenCard">
        {title && (
          <Typography className={classes.examTitle}>{title}</Typography>
        )}

        {props.children}
      </Paper>
    </React.Fragment>
  );
}
